<template>
	<div class="mm-main">
		<router-view></router-view>
	</div>
</template>
<script>
	export default {
		
		data() {
			return {
				
			};
		},
		
	};
</script>
<style>
	.mm-main{  padding: 20px 5px 20px 20px;overflow: hidden; flex: 1; }
	.mm-page-main{ background: #fff; padding: 20px;   height: calc(100% - 40px);  overflow-x: hidden; }
	@media screen and (max-width: 1024px) {
		.mm-main{  padding: 0px;overflow: hidden; flex: 1; }
		.mm-page-main{ background: #fff; padding:10px;   height: calc(100% - 20px);  overflow-x: hidden; }
	 
	}
</style>
